export const HS_PASTE_IMAGE_IDENTIFIER = 'hsPasteImageIdentifier';
export const HS_PASTE_HR_IDENTIFIER = 'hsPasteHrIdentifier';
export const tinymcePasteIdentifierTag = `<meta source='HubSpot-TinyMCE'>`;